<template>
  <DashboardVideo />
  <div
    class="container h-100 d-flex align-items-center justify-content-center z-2"
  >
    <div class="row mobile align-content-between g-0">
      <TypeTopNav
        :heading="this.assetType"
        :routeBack="{ name: 'DashboardHome' }"
      />
      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <div>
              <router-link
                :to="{
                  name: 'AssetView',
                  params: {
                    assetType: 'plusstudio',
                    viewType: 'renders',
                  },
                }"
                class="btn-theme-menu mb-2 border-bottom-left"
              >
                Renders
              </router-link>
              <router-link
                :to="{
                  name: 'VideoView',
                  params: {
                    guid: '3248a60b-33bc-44a8-9c8c-ae39d0555047',
                    collectionId: '539370',
                  },
                }"
                class="border-top-right-radius border-bottom-left-radius btn-theme-menu mb-2 flex"
              >
                <span className="video-label flex-1 ">Cinematics</span>
              </router-link>
              <a
                href="https://retreat.metaluxe.com.au/asset/retreat/balcony-views/view/0"
                target="_blank"
                class="btn-theme-menu mb-2"
                >Balcony Views</a
              >

              <router-link
                :to="{
                  name: 'AssetList',
                  params: {
                    assetType: 'media-packages',
                    viewType: '360-tour',
                  },
                }"
                :class="['btn-theme-menu', 'mb-2']"
              >
                360-tour
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <TypeBotNav />
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import DashboardVideo from "@/components/DashboardVideo.vue";
import TypeTopNav from "@/components/TypeTopNav.vue";
import TypeBotNav from "@/components/TypeBotNav.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from "sort-array";

export default {
  name: "AssetType",
  props: {
    assetType: String,
  },
  components: {
    DashboardVideo,
    TypeTopNav,
    TypeBotNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      collection: null,
      componentName: "AssetView",
      folderStructure: encodeURIComponent(
        this.theme.devFolder + "/assets/plusstudio/" + this.assetType + "/"
      ),
      assetOrder: null,
    };
  },

  created() {
    // BunnyNetService.getFolders(this.folderStructure)
    //   .then((response) => {
    //     // Remap array
    //     const menuItems = response.data.map((item) => {
    //       return {
    //         Guid: item.Guid,
    //         ObjectName: unslugify(item.ObjectName),
    //         LinkName: item.ObjectName,
    //         ComponentName: this.componentName,
    //         Path: item.Path,
    //         IsDirectory: item.IsDirectory,
    //         StorageZoneName: item.StorageZoneName,
    //       };
    //     });
    //     // Assign type menu array
    //     if (this.assetType === "360-tour") {
    //       this.assetOrder = this.theme.tourMenuOrder;
    //     }
    //     // Sort array
    //     console.log(this.assetOrder);
    //     console.log(menuItems);
    //     const customMenu = sortArray(menuItems, {
    //       by: ["LinkName"],
    //       order: "LinkName",
    //       customOrders: {
    //         LinkName: this.assetOrder,
    //       },
    //     });
    //     console.log(customMenu);
    //     this.assetTypes = customMenu;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   }),
    //   BunnyNetService.getCollections(
    //     this.theme.videoLibraryId,
    //     this.collectionName
    //   )
    //     .then((response) => {
    //       this.collection = response.data[0];
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
  },

  setup() {
    // load global config
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
